module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blueimp-gallery blueimp-gallery-controls",
    class: {
      'blueimp-gallery-carousel': _vm.carousel
    },
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "slides"
  }), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }), _vm._v(" "), _c('a', {
    staticClass: "prev"
  }, [_vm._t("prev", function() {
    return [_vm._v("‹")]
  })], 2), _vm._v(" "), _c('a', {
    staticClass: "next"
  }, [_vm._t("next", function() {
    return [_vm._v("›")]
  })], 2), _vm._v(" "), (!_vm.carousel) ? _c('a', {
    staticClass: "close"
  }, [_vm._t("close", function() {
    return [_vm._v("×")]
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.carousel) ? _c('ol', {
    staticClass: "indicator"
  }) : _vm._e(), _vm._v(" "), (_vm.carousel) ? _c('a', {
    staticClass: "play-pause"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04067c08","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-gallery/src/component/gallery.vue
// module id = 2872
// module chunks = 0